module.exports = __webpack_public_path__ + "static/media/Stone Island.7b60e271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/Stone Island.jpg
// module id = 148
// module chunks = 0